import { render, staticRenderFns } from "./OfficesSelector.vue?vue&type=template&id=20483c80&"
import script from "./OfficesSelector.vue?vue&type=script&lang=ts&"
export * from "./OfficesSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports